export default {
	apiKey: "AIzaSyDRtweHpVGoEkJSecbJqcBNbZEq49DE0S0",
	authDomain: "restaurante-tapas.firebaseapp.com",
	databaseURL: "https://restaurante-tapas.firebaseio.com",
	projectId: "restaurante-tapas",
	storageBucket: "restaurante-tapas.appspot.com",
	messagingSenderId: "945076939201",
	appId: "1:945076939201:web:7ee015ad5034fc0b912740",
	measurementId: "G-3P07484481"
};
